/* Mobile collection progress pill: "shown / total" while the grid is on screen. Numbers only. */
if (!customElements.get('kd-browse-progress')) {
  customElements.define('kd-browse-progress', class extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById('product-grid');
      this.total = parseInt(this.dataset.total, 10) || 0;
      if (!this.grid || this.total < 2) return;
      this.update = this.update.bind(this);
      this.mo = new MutationObserver(this.update);
      this.mo.observe(this.grid, { childList: true });
      this.io = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.update();
      });
      this.io.observe(this.grid);
      this.update();
    }
    disconnectedCallback() {
      if (this.mo) this.mo.disconnect();
      if (this.io) this.io.disconnect();
    }
    update() {
      const shown = Math.min(this.grid.children.length, this.total);
      this.textContent = shown + ' / ' + this.total;
      this.hidden = !this.visible;
    }
  });
}

/* Keep the active category chip in view. */
document.addEventListener('DOMContentLoaded', function () {
  var strip = document.querySelector('.kd-cat-strip');
  var active = strip && strip.querySelector('[aria-current]');
  if (active) strip.scrollLeft = active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
});

/* Stick the category strip directly under the pinned header. */
(function () {
  var header = document.querySelector('.section-header header');
  if (!header || !window.ResizeObserver) return;
  var set = function () { document.documentElement.style.setProperty('--kd-strip-top', header.offsetHeight + 'px'); };
  new ResizeObserver(set).observe(header);
  set();
})();
